export default __webpack_public_path__ + "static/media/puffer_cell.4740abf9.jpg";